import { render, staticRenderFns } from "./NotFund.vue?vue&type=template&id=c3de7ff8&"
import script from "./NotFund.vue?vue&type=script&lang=js&"
export * from "./NotFund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports